import React from 'react'

const CSTNavbar = () => {
  return (
    <>
      <nav className="tab-bar hide-for-large-up">
        <section className="middle tab-bar-section">
          <a href="https://cstflightservices.com" id="CSTLogoA">
            <img
              src="img/menu/CST-flight-services-logo.png"
              alt="CST Flight Services logo"
            />
          </a>
        </section>
      </nav>
      {/* <!-- End Menú dispositivos pequeños-->
  <!--Menú dispositivos grandes--> */}

      <nav className="top-bar show-for-large-up" data-topbar="">
        <section className="top-bar-section">
          <ul className="title-area">
            <li className="name">
              <a href="https://cstflightservices.com" id="CSTLogoA">
                <img
                  src="img/menu/CST-flight-services-logo.png"
                  alt="CST Flight Services logo"
                />
              </a>
            </li>
          </ul>
          <br />

          <ul className="right">
            <li className="home">
              <a href="https://cstflightservices.com">
                <img
                  src="img/menu/home.png"
                  alt="CST logo, click here to go home screen"
                />
              </a>
            </li>
          </ul>
        </section>
      </nav>
    </>
  )
}

export default CSTNavbar
